var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"jsonretro__copyBtn",attrs:{"plain":""},on:{"click":_vm.copyJson}},[_vm._v("\n  Copiar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }